import { createContext } from "react";

export const SearchToolbarContext = createContext();
